import React from "react";
import clockicon from "../../Assets/Images/clockicon.svg";
import locationicon from "../../Assets/Images/locationicon.svg";
import emailicon from "../../Assets/Images/emailicon.svg";
import facebookicon from "../../Assets/Images/Facebookicon.png";
import twittercon from "../../Assets/Images/Xicon.png";
import instagramicon from "../../Assets/Images/Instagramicon.png";
import linkedinicon from "../../Assets/Images/Linkdinicon.png";
const GetInTouch = () => {
  return (
    <div className="container">
      <div className="get-in-touch-heading">
        <h1>Get In Touch </h1>
        <p className="get-in-touch-p">
          We deliver a transformative ISO certification experience through our
          unique ‘Consult & Certify’ approach, helping <br /> organisations
          worldwide achieve and maintain global standards.
        </p>
        <p className="get-in-touch-para">
          We deliver a transformative ISO certification experience through our
          unique ‘Consult & Certify’ approach, helping organisations worldwide
          achieve and maintain global standards.
        </p>

        <div className="row get-in-touch-content-section">
          <div className="col-lg-6 let-build-section-heading">
            <h1>
              Let’s build an awesome <br />
              Project together!
            </h1>
            <p>
              If you are interested, Please fill out the form and <br /> our
              team will contact you as soon as possible
            </p>

            <div className="let-bulid-section">
              <div className="d-flex justify-content-center align-items-center gap-3 mt-3">
                <img className="clock-icon" src={clockicon} alt="" />
                <div>
                  <h6 style={{ color: "#043A53" }}>
                    Hours <br />{" "}
                    <span style={{ color: "black" }}>
                      24/5 for Email and Live Chat
                    </span>
                  </h6>
                </div>
              </div>

              <div className="d-flex justify-content-center align-items-center gap-3 mt-3">
                <img className="location-icon" src={locationicon} alt="" />
                <div>
                  <h6 style={{ color: "#043A53" }}>
                    Location <br />{" "}
                    <span style={{ color: "black" }}>
                      71-75 Shelton Street Covent Garden London WC2H 9JQ
                      UNITED KINGDOM
                    </span>
                  </h6>
                </div>
              </div>

              <div className="d-flex justify-content-center align-items-center gap-3 mt-3">
                <img className="email-icon" src={emailicon} alt="" />
                <div>
                  <h6 style={{ color: "#043A53" }}>
                    Email <br />{" "}
                    <span style={{ color: "black" }}>info@eqcas.co.uk</span>
                  </h6>
                </div>
              </div>
            </div>

            <div className="d-flex gap-5  align-items-center mt-5">
              <img className="social-media-icon" src={facebookicon} alt="" />
              <img className="social-media-icon" src={twittercon} alt="" />
              <img className="social-media-icon" src={instagramicon} alt="" />
              <img className="social-media-icon" src={linkedinicon} alt="" />
            </div>
          </div>
          <div className="col-lg-6 form-container  rounded-4">
            <form>
              <div className="form-group mb-4 position-relative">
                <label className="floating-label">Name</label>
                <input
                  type="text"
                  className="form-control form-inputbox"
                  placeholder="Enter Your Name"
                />
              </div>

              <div className="form-group mb-4 position-relative">
                <label className="floating-label">Email</label>
                <input
                  type="email"
                  className="form-control form-inputbox"
                  placeholder="Enter Your Email"
                />
              </div>

              <div className="form-group mb-4 position-relative">
                <label className="floating-label">Phone</label>
                <input
                  type="tel"
                  className="form-control form-inputbox"
                  placeholder="Enter Your Phone"
                />
              </div>

              <div className="form-group mb-4 position-relative">
                <label className="floating-label">Message</label>
                <textarea
                  className="form-control form-inputbox"
                  rows="4"
                  placeholder="Write here Your Message"
                ></textarea>
              </div>

              <button
                type="submit"
                className="btn btn-light w-100 fw-bold get-in-form-btn"
              >
                Send
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GetInTouch;
